import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, switchMap } from 'rxjs/operators'
import { catchErrorAlert } from '@adex/shared/utils/errors'
import {
  createNotification,
  deleteNotification,
  editNotification,
  loadNotifications,
  navigate,
  notificationMessage,
  setNotifications
} from '@adex/store/actions'
import { appRoutes } from '@adex/shared/routing/routes'
import { NotificationNetworkService } from '../services/notification-network.service'


@Injectable()
export class NotificationsEffects {

  private readonly loadNotificationsData$ = createEffect(() => this.actions$.pipe(
    ofType(loadNotifications),
    switchMap(() => this.network.getNotificationsList().pipe(
      map(data => setNotifications({ data })),
      catchErrorAlert()
    ))
  ))

  private readonly createNotification$ = createEffect(() => this.actions$.pipe(
    ofType(createNotification),
    switchMap(({ data }) => this.network.createNotification(data).pipe(
      mergeMap(() => [
        loadNotifications(),
        navigate({ commands: appRoutes.app.notifications.channels.settings })
      ]),
      catchErrorAlert()
    ))
  ))

  private readonly editNotification$ = createEffect(() => this.actions$.pipe(
    ofType(editNotification),
    switchMap(({ data }) => this.network.editNotification(data).pipe(
      mergeMap(() => [
        loadNotifications(),
        navigate({ commands: appRoutes.app.notifications.channels.settings })
      ]),
      catchErrorAlert()
    ))
  ))

  private readonly deleteNotification$ = createEffect(() => this.actions$.pipe(
    ofType(deleteNotification),
    switchMap(({ id }) => this.network.deleteNotification(id).pipe(
      mergeMap(() => [
        loadNotifications(),
        notificationMessage({ message: 'NOTIFICATIONS.NOTIFICATION_DELETED' })
      ]),
      catchErrorAlert()
    ))
  ))

  constructor(private readonly actions$: Actions, private readonly network: NotificationNetworkService) {
  }

}
